import { commonActions, commonConstants as cc } from 'srcReact/components'
import { createUpdateGroupConstants as gc } from 'srcReact/GroupPage'
import { userService, groupService, generalService } from 'srcReact/services'
import { isEmpty } from 'srcReact/helpers/validator'

export const createUpdateGroupActions = {
  getWorkplacesForCreation,
  setSelectedWorkplace,
  setGroupName,
  setSkipPicture,
  setDescription,
  setLocation,
  setGroupPicture,
  setGroupType,
  setPrivacySetting,
  createGroup,
  setMixrSetting,
  setMemberSetting,
  setAdmissionSetting,
  setMemberSettingAge,
  showLocation,
  showInterests,
  showPictureUpload,
  showPrivacySetting,
  setFormAsCompleted,
  setValidationErrors,
  removeGroupPicture,
  showDescription,
  showAdvSetting,
  showGroupName,
  showGroupType,
  setAsGeneralGroup,
  clearData,
  clearErrors,
  editGroup,
  getGroupDetailById,
  addSelectedInterests
}

function setAsGeneralGroup() {
  return { type: gc.SET_AS_GENERAL_GROUP }
}

function showGroupName() {
  return { type: gc.SHOW_GROUP_NAME }
}

function showGroupType() {
  return { type: gc.SHOW_GROUP_TYPE }
}

function showDescription() {
  return { type: gc.SHOW_DESCRIPTION }
}

function removeGroupPicture() {
  return { type: gc.REMOVE_GROUP_PICTURE }
}

function setValidationErrors(validationErrors) {
  return { type: gc.SET_VALIDATION_ERRORS, validationErrors }
}

function showPrivacySetting() {
  return { type: gc.SHOW_PRIVACY_SETTING }
}

function setFormAsCompleted() {
  return { type: gc.SET_FORM_COMPLETED }
}
function showPictureUpload() {
  return { type: gc.SHOW_PICTURE_UPLOAD }
}
function showLocation() {
  return { type: gc.SHOW_LOCATION }
}
function showInterests() {
  return { type: gc.SHOW_INTERESTS }
}
function showAdvSetting() {
  return { type: gc.SHOW_ADV_SETTING }
}

function getWorkplacesForCreation(organizationId) {
  return (dispatch) => {
    dispatch(request(organizationId))

    groupService.getWorkplacesByOrgId(organizationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gc.GET_WORKPLACES_REQUEST, response }
  }
  function success(response) {
    return { type: gc.GET_WORKPLACES_SUCCESS, response }
  }
  function failure(error) {
    return { type: gc.GET_WORKPLACES_FAILURE, error }
  }
}

function createGroup(workplaceId, group) {
  return (dispatch) => {
    dispatch(request(workplaceId))

    groupService.createGroup(workplaceId, group).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gc.CREATE_GROUP_REQUEST, response }
  }
  function success(response) {
    return { type: gc.CREATE_GROUP_SUCCESS, response }
  }
  function failure(error) {
    return { type: gc.CREATE_GROUP_FAILURE, error }
  }
}

function setSelectedWorkplace(workplace) {
  return { type: gc.SET_SELECTED_WORKPLACE, workplace }
}

function setGroupName(groupName) {
  return { type: gc.SET_GROUP_NAME, groupName }
}

function setGroupType(groupType) {
  return { type: gc.SET_GROUP_TYPE, groupType }
}

function setSkipPicture() {
  return { type: gc.SET_SKIP_PICTURE }
}
function setDescription(description) {
  return { type: gc.SET_GROUP_DESCRIPTION, description }
}
function setLocation(location) {
  return { type: gc.SET_GROUP_LOCATION, location }
}

function setGroupPicture(picture) {
  return { type: gc.SET_GROUP_PICTURE, picture }
}

function setPrivacySetting(group) {
  return { type: gc.SET_PRIVACY_SETTING, group }
}

function setMixrSetting(canMemberSuggestMixr) {
  return { type: gc.CAN_MEMBER_SUGGEST_MIXR, canMemberSuggestMixr }
}

function setMemberSetting(setting) {
  return { type: gc.SET_MEMBER_SETTING, setting }
}

function setAdmissionSetting(autoApproveToJoin) {
  return { type: gc.SET_AUTO_APPROVAL_TO_JOIN, autoApproveToJoin }
}

function setMemberSettingAge(age) {
  return { type: gc.SET_MEMBER_AGE_SETTING, age }
}

function clearData() {
  return { type: gc.CLEAR_DATA }
}

function clearErrors() {
  return { type: gc.CLEAR_ERRORS }
}

function editGroup(groupId, group) {
  return (dispatch) => {
    dispatch(request(groupId))

    groupService.editGroup(groupId, group).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gc.EDIT_GROUP_REQUEST, response }
  }
  function success(response) {
    return { type: gc.EDIT_GROUP_SUCCESS, response }
  }
  function failure(error) {
    return { type: gc.EDIT_GROUP_FAILURE, error }
  }
}

function getGroupDetailById(groupId) {
  return (dispatch) => {
    dispatch(request(groupId))

    groupService.getGroupDetailById(groupId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gc.GET_GROUP_DETAIL_REQUEST, response }
  }
  function success(response) {
    return { type: gc.GET_GROUP_DETAIL_SUCCESS, response }
  }
  function failure(error) {
    return { type: gc.GET_GROUP_DETAIL_FAILURE, error }
  }
}

function addSelectedInterests(interestsArr) {
  return { type: gc.SELECT_INTERESTS, interestsArr }
}
